import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import { addToast } from '@mobi/component-library/Feedback/Toast'
import { hideLogin, refreshLogonState } from '@core/Areas/Login/helpers'
import { useObservableImmutable } from '@core/Utils/hooks'
import { appHistory } from '@core/Utils/routing/history'
import { setIsBiometricsEnabledOnTempPasswordChange } from '../Login/Store'
import { getIsBiometricsEnabledOnTempPasswordChange } from '../Login/Store/selectors'
import { ChangePasswordViewObserve } from './ChangePassword'
import { CHANGE_TEMP_PASSWORD_ROUTE } from './constants'
import { Reset, UpdateCurrentPassword, state$ } from './driver'

export const navigateToChangeTempPassword = ({
  accountNumber,
  password,
}: NavigateToChangeTempPassword) => {
  UpdateCurrentPassword(password)
  appHistory.push(`/${CHANGE_TEMP_PASSWORD_ROUTE}/${accountNumber}`)
  hideLogin()
}

export const ChangeTemporaryPassword = () => {
  const dispatch = useDispatch()
  const { accountNumber } = useParams<{ accountNumber?: string }>()
  const { isChangeTemporaryPasswordSuccess } = useObservableImmutable(state$, [
    'isChangeTemporaryPasswordSuccess',
  ])
  const isBiometricsEnabledOnTempPasswordChange = useSelector(
    getIsBiometricsEnabledOnTempPasswordChange
  )

  React.useEffect(() => Reset, [])

  React.useEffect(() => {
    if (!accountNumber) appHistory.push('/')
  }, [accountNumber])

  React.useEffect(() => {
    if (isChangeTemporaryPasswordSuccess) {
      refreshLogonState()
      appHistory.push('/')
      addToast({ id: 'change-password', title: 'Password Changed', icon: 'success' })
      if (isBiometricsEnabledOnTempPasswordChange)
        dispatch(setIsBiometricsEnabledOnTempPasswordChange(false))
    }
  }, [dispatch, isChangeTemporaryPasswordSuccess, isBiometricsEnabledOnTempPasswordChange])

  if (!accountNumber) {
    return null
  }

  return (
    <ChangePasswordViewObserve
      accountNumber={accountNumber}
      isChangeTemporaryPassword
      isDesktop={false}
    />
  )
}

// Types

interface NavigateToChangeTempPassword {
  accountNumber: string
  password: string
  isTogglingBiometricsOn?: boolean
}
